const baseUrl = `${process.env.VUE_APP_SERVER_URL}/AnaliseCobertura`;

type SimulationExames = {
  CodigoExame: string;
  Descricao: string;
  PossuiCobertura: boolean;
  ExigeAutorizacao: boolean;
  RequerDut: boolean;
};

type SimulationLaboratorio = {
  Nome: string;
  CodigoPrestador: string;
  Unidade: string;
  SrEndereco: number;
  Endereco: string;
  Distancia: number;
};

export async function ValidarLimiteSimulacao({ vinculo }): Promise<{
  Data: {
    Autorizado: boolean;
  };
}> {
  const query = {
    vinculo
  };

  return globalThis.window.$axios
    .get({
      url: `${baseUrl}/ValidarLimiteSimulacao`,
      query
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ValidarLimiteSimulacao", error.message);
      throw new Error(error.message);
    });
}

export async function IncluirSimulacao({
  vinculo,
  obterLaboratorios,
  exames
}: {
  vinculo: string;
  obterLaboratorios: boolean;
  exames: SimulationExames[];
}): Promise<{
  Data: {
    IdSimulacao: number;
    Laboratorios: SimulationLaboratorio[];
  };
}> {
  return globalThis.window.$axios
    .post({
      url: `${baseUrl}/IncluirSimulacao`,
      query: {
        vinculo
      },
      data: {
        obterLaboratorios,
        exames
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("IncluirSimulacao", error.message);
      throw new Error(error.message);
    });
}

export async function RemoverSimulacao({ vinculo, IdSimulacao }) {
  const query = {
    vinculo
  };

  const body = {
    IdSimulacao
  };

  return globalThis.window.$axios
    .post({
      url: `${baseUrl}/RemoverSimulacao`,
      query,
      data: body
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("RemoverSimulacao", error.message);
      throw new Error(error.message);
    });
}

export type Simulation = {
  IdSimulacao: number;
  Periodo: string;
  Quantidade: number;
  PossuiCobertura: boolean;
  ExigeAutorizacao: boolean;
  SalvoEm: string;
  Exames: SimulationExames[];
};

export async function ListarSimulacoes({ vinculo }): Promise<{
  Data: Simulation[];
}> {
  const query = {
    vinculo
  };

  return globalThis.window.$axios
    .get({
      url: `${baseUrl}/ListarSimulacoes`,
      query
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ListarSimulacoes", error.message);
      throw new Error(error.message);
    });
}

export async function ListarExames({ vinculo, exame }): Promise<{
  Data: {
    CodigoExame: string;
    Descricao: string;
    PossuiCobertura: boolean;
    ExigeAutorizacao: boolean;
  }[];
}> {
  const query = {
    vinculo,
    exame
  };

  return globalThis.window.$axios
    .get({
      url: `${baseUrl}/ListarExames`,
      query
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ListarExames", error.message);
      throw new Error(error.message);
    });
}

export async function ListarLaboratorios({ vinculo, prestador, idSimulacao }): Promise<{
  Data: SimulationLaboratorio[];
}> {
  const query = {
    vinculo
  };

  return globalThis.window.$axios
    .post({
      url: `${baseUrl}/ListarLaboratorios`,
      query,
      data: {
        prestador: prestador || undefined,
        idSimulacao
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ListarLaboratorios", error.message);
      throw new Error(error.message);
    });
}
